import { render, staticRenderFns } from "./Clientemaildashboard.vue?vue&type=template&id=7b53590f&"
import script from "./Clientemaildashboard.vue?vue&type=script&lang=js&"
export * from "./Clientemaildashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports